import { render, staticRenderFns } from "./ShanghaiClassSelector.vue?vue&type=template&id=46c85b49&scoped=true&"
import script from "./ShanghaiClassSelector.vue?vue&type=script&lang=js&"
export * from "./ShanghaiClassSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c85b49",
  null
  
)

export default component.exports